module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAABgAQAAAAAS7+6fAAAADUlEQVQI12P4wDCkIQDCr1oBgVC14wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_top_part_vertical_line.png
// module id = DcWr
// module chunks = 5